import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface MarkdownDisplayProps {
  content: string | null | undefined;
  className?: string;
  emptyMessage?: string;
  emptyMessageClassName?: string;
}

const MarkdownDisplay: React.FC<MarkdownDisplayProps> = ({
  content,
  className,
  emptyMessage,
  emptyMessageClassName = 'italic text-muted-foreground',
}) => {
  const { t } = useTranslation();
  if (!content || content.trim() === '') {
    return <span className={emptyMessageClassName}>{emptyMessage ?? t('useCaseOverview.notDefined')}</span>;
  }

  return (
    <div
      className={cn(
        'prose prose-sm dark:prose-invert max-w-none',
        'prose-headings:text-foreground prose-headings:font-semibold',
        'prose-h1:text-2xl prose-h1:border-b prose-h1:border-border prose-h1:pb-2 prose-h1:mb-4',
        'prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3',
        'prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-2',
        'prose-p:text-foreground prose-p:leading-relaxed',
        'prose-li:text-foreground',
        'prose-strong:text-foreground prose-strong:font-semibold',
        'prose-a:text-brand-secondary prose-a:no-underline hover:prose-a:underline',
        'prose-code:text-foreground prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded',
        'prose-pre:bg-muted prose-pre:border prose-pre:border-border',
        'prose-blockquote:border-l-primary prose-blockquote:text-muted-foreground',
        'prose-table:border prose-table:border-border',
        'prose-th:bg-muted prose-th:border prose-th:border-border prose-th:px-3 prose-th:py-2',
        'prose-td:border prose-td:border-border prose-td:px-3 prose-td:py-2',
        className
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownDisplay;

